import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

import { STATE_LOADING, STATE_SUCCESS } from 'Store/commonActions';

export const selectFacebook = createKeySelector('facebook');

export const getIsFacebookTokenSubmissionInProgress = createSelector(
  selectFacebook,
  (facebook): boolean => facebook.facebookTokenState === STATE_LOADING
);

export const getIsFacebookTokenValidationSuccessful = createSelector(
  selectFacebook,
  (facebook): boolean => facebook.facebookTokenState === STATE_SUCCESS
);

export const getIsFacebookSdkBlocked = createSelector(
  selectFacebook,
  (facebook) => facebook.facebookSdkBlocked
);

export const getIsFacebookInitialized = createSelector(
  selectFacebook,
  (facebook) => facebook.facebookInitialized
);
